'use client'

import { useSearchParams } from 'next/navigation'

import CarStoryDrivePage from './CarStoryDrivePage'
import CarStoryHomePage from './CarStoryHomePage'
import CarStoryMaintenancePage from './CarStoryMaintenancePage'
import CarStoryNowPage from './CarStoryNowPage'
import CarStoryTopNavigation from './CarStoryTopNavigation'

const TAB_CONTENT = {
  home: CarStoryHomePage,
  drive: CarStoryDrivePage,
  maintenance: CarStoryMaintenancePage,
  now: CarStoryNowPage,
} as const

type TTabKey = keyof typeof TAB_CONTENT

const HUB_HEADING = '마이클 차량 이야기'

const CarStoryPage = () => {
  const searchParams = useSearchParams()
  const tab = (searchParams.get('tab') ?? 'home') as TTabKey
  const Content = TAB_CONTENT[tab] ?? TAB_CONTENT.home

  return (
    <>
      <h1 className='sr-only'>{HUB_HEADING}</h1>
      <CarStoryTopNavigation />
      <Content />
    </>
  )
}

export default CarStoryPage
